import React from "react";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { TankCladdingType } from "__generated__/enums";
import { intl } from "LocaleWrapper";

const ShipTankCladdingTypeSelect = ({ value, onChange }: Omit<SelectProps<TankCladdingType, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={[ TankCladdingType.Coating, TankCladdingType.MildSteel, TankCladdingType.StainlessSteel ]}
			getOptionLabel={option => intl.formatMessage({ id: `SHIP_TANK_CLADDING_TYPE_${option}` })}
			value={value}
			onChange={onChange}
			clearable={false}
			disableSearch />
	);
};

export default ShipTankCladdingTypeSelect;
